export class BasicRightGroupInformation {
    public id: string;
    public name: string | null = '';

    constructor();
    constructor(rightGroupId: string, rightGroupName: string | null);
    constructor(rightGroupId?: string, rightGroupName?: string | null) {
        if (rightGroupId !== undefined) {
            this.id = rightGroupId;
        }
        
        if (rightGroupName !== undefined) {
            this.name = rightGroupName;
        }        
    }
}